import {
  getPriceHtFromTtc,
  getPriceWithDiscount,
  getTvaAmountFromPriceHtAndTva,
} from 'src/app/services/helpers/formula-helper';
import { ShoppingCartProductCategory } from './shopping-cart-product-category';
import { ShoppingCartAssistance } from './shopping-cart-assistance';

export class ShoppingCartProductList {
  public shoppingCartProductCategories: ShoppingCartProductCategory[];
  public shoppingCartAssistances: ShoppingCartAssistance[];

  constructor(shoppingCartProductCategory: ShoppingCartProductCategory[] = []) {
    this.shoppingCartProductCategories = shoppingCartProductCategory;
  }

  get totalAssistancePriceHt(): number {
    let total = 0;
    if (this.shoppingCartAssistances != undefined) {
      for (const assistance of this.shoppingCartAssistances) {
        total += getPriceHtFromTtc(assistance.priceTtc, assistance.tva);
      }
    }
    return total;
  }

  get totalAssistancePriceTtc(): number {
    let total = 0;
    if (this.shoppingCartAssistances != undefined) {
      for (const assistance of this.shoppingCartAssistances) {
        total += assistance.priceTtc;
      }
    }
    return total;
  }

  get totalAssistanceTva(): number {
    let total = 0;
    if (this.shoppingCartAssistances != undefined) {
      for (const assistance of this.shoppingCartAssistances) {
        total += getTvaAmountFromPriceHtAndTva(getPriceHtFromTtc(assistance.priceTtc, assistance.tva), assistance.tva);
      }
    }
    return total;
  }

  get totalPriceHt(): number {
    let total = 0;
    for (const category of this.shoppingCartProductCategories) {
      for (const product of category.shoppingCartProducts) {
        total += product.unitPriceHtFull * product.quantity + product.totalPriceAccessoryTtc - product.tvaAccessory;
      }
    }
    total += this.totalAssistancePriceHt;
    return total;
  }

  get totalPriceDiscountHt(): number {
    let totalNotDiscount: number = 0;
    let total: number = undefined;
    for (const category of this.shoppingCartProductCategories) {
      for (const product of category.shoppingCartProducts) {
        if (product.discount != undefined && product.discount != 0) {
          if (total == undefined) {
            total = 0;
          }
          total +=
            (getPriceWithDiscount(product.unitPriceHt, product.discount) + product.unitEcoTax) * product.quantity +
            product.totalPriceAccessoryTtc -
            product.tvaAccessory;
        } else {
          totalNotDiscount +=
            product.unitPriceHtFull * product.quantity + product.totalPriceAccessoryTtc - product.tvaAccessory;
        }
      }
    }
    return total != undefined ? total + totalNotDiscount + this.totalAssistancePriceHt : total;
  }

  get totalPriceTtc(): number {
    let total = 0;
    for (const category of this.shoppingCartProductCategories) {
      total += category.totalPriceTtc;
    }

    total += this.totalAssistancePriceTtc;
    return total;
  }

  get totalPriceDiscountTtc(): number {
    let totalNotDiscount: number = 0;
    let total: number = undefined;
    for (const category of this.shoppingCartProductCategories) {
      for (const product of category.shoppingCartProducts) {
        if (product.discount != undefined && product.discount != 0) {
          if (total == undefined) {
            total = 0;
          }
          total += product.totalPriceDiscountTtc + product.totalPriceAccessoryTtc;
        } else {
          totalNotDiscount += product.totalPriceTtc + product.totalPriceAccessoryTtc;
        }
      }
    }
    return total != undefined ? total + totalNotDiscount + this.totalAssistancePriceTtc : total;
  }

  get ecoTax(): number {
    let total = 0;
    for (const category of this.shoppingCartProductCategories) {
      total += category.ecoTax ?? 0;
    }
    return total;
  }

  get tva(): number {
    let total = 0;
    for (const category of this.shoppingCartProductCategories) {
      total += category.tva;
    }

    total += this.totalAssistanceTva;
    return total;
  }

  get tvaDiscount(): number {
    let totalNotDiscount: number = 0;
    let total: number = undefined;
    for (const category of this.shoppingCartProductCategories) {
      for (const product of category.shoppingCartProducts) {
        if (product.discount != undefined && product.discount != 0) {
          if (total == undefined) {
            total = 0;
          }
          total +=
            getTvaAmountFromPriceHtAndTva(
              (getPriceWithDiscount(product.unitPriceHt, product.discount) + product.unitEcoTax) * product.quantity,
              product.tva
            ) + product.tvaAccessory;
        } else {
          totalNotDiscount +=
            getTvaAmountFromPriceHtAndTva(product.unitPriceHtFull * product.quantity, product.tva) +
            product.tvaAccessory;
        }
      }
    }
    return total != undefined ? total + totalNotDiscount + this.totalAssistanceTva : total;
  }
}
